<template>
    <Navbar :title="NavbarTitle"></Navbar>
    <div class="policy-detail">
        <policy-detail-header :detail="detail" :type="btnType"></policy-detail-header>
        <div v-if="type == 'order'">
            <div class="card">
                <div class="card-title">
                    <div class="flex-title-text">
                        进度记录
                    </div>
                </div>
                <div class="card-content">
                    <div v-if="detail.orderRecords">
                        <van-steps direction="vertical"
                            :active="detail.orderRecords.length ? detail.orderRecords.length - 1 : 0">
                            <van-step v-for="step in detail.orderRecords" :key="step">
                                <div>{{ step.processCreateTime }}</div>
                                <div>{{ step.content }}</div>
                            </van-step>
                        </van-steps>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-for="item in items" :key="item.title">
            <div v-if="item.content">
                <div class="card-title">
                    <div class="flex-title-text">
                        {{ item.title }}
                    </div>
                </div>
                <div class="card-content" v-if="item.content">
                    <!-- {{ item.content }} -->
                    <div v-html="item.content"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="float-action">
        <div class="flex-item btn-collect-box" v-if="btnType != '2'">
            <van-button class="btn btn-collect btn-favorite" v-if="!favorite" @click="doFav(true)">
                <!-- <van-icon class="icon" name="star" color="#fff" size="20" /> -->
                <img class="icon-favorite" src="@/assets/images/icon_favorite_1@2x.png">
                收藏
            </van-button>
            <van-button class="btn btn-favorite-active" v-else @click="doFav(false)">
                <!-- <van-icon class="icon" name="star-o" color="#ffe4a8" size="20" /> -->
                <img class="icon-favorite" src="@/assets/images/icon_favorite_2@2x.png">

                取消收藏
            </van-button>
        </div>
        <div class="flex-item btn-consult-box" v-if="btnType == '1' && detail.status == '1'">
            <van-button class="btn btn-consult" @click="doDeclare">
                <van-icon class="icon" name="chat-o" color="#fff" size="20" />
                一键申报
            </van-button>
        </div>
        <div class="flex-item btn-consult-box" v-if="btnType == '2'">
            <van-button class="btn" type="danger" @click="doTel">联系服务商</van-button>
        </div>
    </div>

    <div v-if="declareShow">
        <declare-model :show="declareShow" :list="declareList" @declareSelected="declareSelected" @closeDeclare="closeDeclare"></declare-model>
    </div>

    <van-dialog v-model:show="showCompany" title="确认企业信息" show-cancel-button @confirm="submit" @cancel="cancel">
        <van-form>
            <van-cell-group inset>
                <van-field v-model="formCompany.name" name="企业名称" placeholder="企业名称" />
                <van-field v-model="formCompany.phone" name="联系号码" placeholder="联系号码" />
            </van-cell-group>
        </van-form>
    </van-dialog>
</template>

<script>

import { Dialog, Notify } from "vant"
import { queryById, queryOrderById, getServiceProviderList, addFavorite, cancelFavorite, queryFavorite,queryUserById } from "@/api/home"
import moment from "moment"
import { info, cache, ws } from "@/api"
import Select from '@/components/Select.vue'
import SearchDetail from '@/components/SearchDetail.vue'
import Date from '@/components/Date.vue'
import Area from '@/components/Area.vue'
import Navbar from '@/components/Navbar'
import PolicyDetailHeader from "@/components/PolicyDetailHeader.vue"
import DeclareModel from '@/components/DeclareModel'
import { clickUrlToPhone } from '@/utils/index'
import { getUserInfo,getUserId } from '@/utils/storage'

export default {

    data() {
        return {
            detail: {
                serviceProviderTel: ''
            },
            items: [],
            declareShow: false,
            formCompany: {},
            showCompany: false,
            declareList: [],
            NavbarTitle: '',
            btnType: 0,
            favorite: false,
            queryCompany: {},
            company:{}
        }
    },
    components: { Select, SearchDetail, Date, Area, Navbar, PolicyDetailHeader, DeclareModel },
    computed: {},
    watch: {},
    mounted() {
        this.init()
    },
    watch: {},
    methods: {
        init() {
            this.userId = getUserId() ? getUserId() : ''
            this.id = this.$route.query.id
            this.policyId = this.$route.query.policyId ? this.$route.query.policyId : ''
            this.NavbarTitle = this.$route.query.title
            this.btnType = this.$route.query.btnType
            this.type = this.$route.query.type || ''
            this.queryCompany =  this.$route.query.company ? JSON.parse(this.$route.query.company) : {}
            this.getData()
            // if(this.type != 'order'){
            //     this.queryFavorite()
            // }
            // this.getCompany()
        },
        async queryFavorite() {
            let res = await queryFavorite({policyId:this.policyId})
            this.favorite = res.data.flag
        },
        async doFav(type) {
            const request = type ? addFavorite : cancelFavorite
            let res = await request({policyId:this.policyId})
            this.$toast.success({ message: type ? '收藏成功' : '取消收藏成功', duration: 2000 })
            setTimeout(() => {
                this.queryFavorite()
                this.getData()
            }, 2000)
        },
        async getData() {
            let request = this.type == 'order' ? queryOrderById : queryById
            let res = await request({ 'id': this.id })
            this.detail = res.data
            if(this.type == 'order' && res.data.policyId){
               this.detail.policyTitle = res.data.policy.policyTitle
            }
            this.items = [
                { title: '核心内容', content: res.data.coreContent },
                { title: '扶持条件', content: res.data.supportConditions },
                { title: '申报材料', content: res.data.filingMaterials },
                { title: '申报流程', content: res.data.declarationProcess },
                { title: '联系方式', content: res.data.contactPhone },
                // { title: '政策文件', content: res.data.dispatchDepartment }
            ]
            if (res.data.status == '1') {
                this.getDeclareList()
            }
        },
        async getDeclareList() {
            let res = await getServiceProviderList()
            this.declareList = res.data
        },
        doDeclare() {
            console.log(5346)
            this.declareShow = true
        },
        declareSelected(arg) {
            this.declareShow = false
            let query = {
                type: 'getPhone',
                declare_id: this.declareInfo.id,
                serviceProviderId: arg.id
            }
            clickUrlToPhone('', query)
        },
        submit() {
            this.getData()
            this.showCompany = false
        },
        cancel() {
            this.formCompany = {}
            this.showCompany = false
        },
        doTel() {
            if (!this.detail.provider.phone) {
                this.$toast('暂无服务商电话')
                return false
            }
            clickUrlToPhone('', { phone: this.detail.provider.phone, type: 'getTel' })
        },
        closeDeclare(){
          this.declareShow = false
          this.formCompany = {}
        },
        async getCompany(){
            let res = await queryUserById({userId: getUserInfo() ? JSON.parse(getUserInfo()).userId : ''})
            this.company = res.data || {}
        },
    }
}
</script>

<style lang="scss" scoped>
.policy-detail{
    padding-bottom: 100px;
}
.flex-item .btn {
    width: 100%;
    height: 60px;
}

.wrap-box-title {
    padding: 0 13px;
    font-size: 16px;
    font-weight: 600;
    color: #006D9B;
    line-height: 19px;

    &.wrap-box-d {

        margin: 20px 0;
        border-radius: 8px;
        padding: 10px 0 15px;

        .card-title {
            &:before {
                width: 4px;

                border-left: 4px solid #F3B30E;
            }
        }
    }
}


</style>
